import { Link } from 'react-router-dom';

interface LinkCardProps {
  icon: string;
  label: string;
  subtitle?: string;
  to?: string;
  href?: string;
  external?: boolean;
  variant?: 'primary' | 'default';
}

export default function LinkCard({
  icon,
  label,
  subtitle,
  to,
  href,
  external = false,
  variant = 'default',
}: LinkCardProps) {
  const isPrimary = variant === 'primary';

  const baseClasses = `group flex items-center gap-4 rounded-xl px-4 py-4 md:px-5 md:py-5 transition-all duration-200 cursor-pointer border whitespace-nowrap ${
    isPrimary
      ? 'bg-hop-orange-cta border-hop-orange-cta hover:bg-hop-orange-hover'
      : 'bg-white border-hop-border hover:border-hop-orange'
  }`;

  const content = (
    <>
      <div
        className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg flex-shrink-0 ${
          isPrimary ? 'bg-white/15 text-white' : 'bg-hop-orange/10 text-hop-orange'
        }`}
      >
        <i className={`${icon} text-lg md:text-xl`}></i>
      </div>
      <div className="flex-1 min-w-0 text-left">
        <p
          className={`font-semibold text-sm md:text-base leading-tight truncate ${
            isPrimary ? 'text-white' : 'text-hop-graphite'
          }`}
        >
          {label}
        </p>
        {subtitle && (
          <p
            className={`text-xs md:text-sm font-light mt-0.5 truncate ${
              isPrimary ? 'text-white/80' : 'text-hop-text-secondary'
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>
      <div
        className={`w-6 h-6 flex items-center justify-center flex-shrink-0 ${
          isPrimary
            ? 'text-white'
            : 'text-hop-text-secondary group-hover:text-hop-orange'
        }`}
      >
        <i className="ri-arrow-right-line text-sm"></i>
      </div>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={baseClasses}>
        {content}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      className={baseClasses}
    >
      {content}
    </a>
  );
}